import { render, staticRenderFns } from "./GroupTree.vue?vue&type=template&id=0a7edc54&scoped=true"
import script from "./GroupTree.ts?vue&type=script&lang=ts&external"
export * from "./GroupTree.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupTree.vue?vue&type=style&index=0&id=0a7edc54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7edc54",
  null
  
)

export default component.exports